export { ProductStaticContent } from './ProductStaticContent';
